import { render, staticRenderFns } from "./ArrowInIcon.vue?vue&type=template&id=3e476ef4&"
import script from "./ArrowInIcon.vue?vue&type=script&lang=ts&"
export * from "./ArrowInIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports